import { Component, ElementRef, Inject, Input, OnInit, Output,EventEmitter, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { Menu, NavService } from '../../services/nav.service';
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  sidebarCollapsed = false;
  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleDoubleRight = faAngleDoubleRight;
  versionNo: any;
  public menuItems: Menu[];
  public url: any;
  activateSideNav = false;
  menujsonlist: any = {};
  isEmptyObj: boolean = true;
  roleRightObj: {};
  deploymentName:any;
  fetchDeploymentName:any;
  @Output() sendMouseEvent:EventEmitter<any> = new EventEmitter();
  constructor(
    @Inject('version') private version: string,
    private router: Router,
    private navServices: NavService,
    public elRef: ElementRef,
    public authService: AuthService, @Inject('edgeEndPoint') private edgeUrl: string
  ) {
    let roleRightsJson = JSON.parse(localStorage.getItem('sideMenuList'));

   this.roleRightObj = {};
   if(roleRightsJson && roleRightsJson.length !=0){
    for (let i = 0; i < roleRightsJson.length; i++) {
      const blockname = roleRightsJson[i].block_name;
      const data = roleRightsJson[i].data;
      const right = {};
      for (let j = 0; j < roleRightsJson[i].data.length; j++) {
        const pagename = roleRightsJson[i].data[j].page_name;
        const value = roleRightsJson[i].data[j].read
        right[pagename] = value;
      }

      this.roleRightObj[blockname] = right;
    };
  }


    // //console.log(this.roleRightObj);

    // this.menuItems = [
    //   {
    //     path: '/dashboard', title: 'Home', read: false, roleRight: 'home', type: 'link', icon: 'fas fa-home', active: true
    //   },
    //   // {
    //   //   path: '/topology', title: 'Topology', read: false, roleRight: 'topology', type: 'link', icon: 'la la-rocket',
    //   // },

    //   // { headTitle: 'Visibility' }, 
    //   {
    //     title: 'Visibility', icon: 'fas fa-globe-africa', read: false, roleRight: 'networkModel', type: 'sub', active: false,
    //     children: [
    //       {
    //         path: '/assets', title: 'Assets', read: false, roleRight: 'assets', type: 'link', icon: 'la la-rocket', 
    //       },
    //       { path: '/alaram-dashboard', title: 'Alarms', read: true, roleRight: 'alarms-manager', icon: 'fa-siren-on', type: 'link' },

    //       {
    //         path: '/walktest-detailed-report', title: 'Detailed Report', read: false, roleRight: 'walk_test_detailed_report', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/walktest-report', title: 'Walk Test View', read: false, roleRight: 'walk_test_report', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/walktest-report-table', title: 'Download CSV Data', read: false, roleRight: 'active_test_report', type: 'link', icon: 'la la-rocket', 
    //       },
    //       {
    //         path: '/walktest-summary', title: 'Walk Test Summary', read: false, roleRight: 'walk_test_summary', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/wifi-logs', title: 'WiFi Logs', read: false, roleRight: 'wifi-logs', type: 'link', icon: 'la la-rocket', 
    //       },
    //       {
    //         path: '/cell-analysis', title: 'Physical Cell Analysis Report', read: false, roleRight: 'physcial_cell_analysis_report', type: 'link', icon: 'la la-rocket', 
    //       },
    //       {
    //         path: '/statistics', title: 'Statistics', read: false, roleRight: 'statistics', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/signal-heatmap', title: 'Signal Heatmap', read: false, roleRight: 'signal_heat_map', type: 'link', icon: 'la la-rocket'
    //       },
    //       {
    //         path: '/kpidashboard', title: 'Dashboard', read: false, roleRight: 'dashboard', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/telemetry', title: 'Telemetry', read: false, roleRight: 'telemetry', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/globalCompCharts', title: 'Global Comparison Charts', read: false, roleRight: 'global_comparison', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/test-reports', title: 'Automation Test Reports', read: false, roleRight: 'automation_report', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/gps-report', title: 'GPS Report', read: false, roleRight: 'gps_report', type: 'link', icon: 'la la-rocket',
    //       },
          
    //       {
    //         path: '/devices', title: 'Devices', read: false, roleRight: 'devices', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/sensors', title: 'Sensors', read: false, roleRight: 'sensors', type: 'link', icon: 'la la-rocket',
    //       },

    //       {
    //         path: '/edge-rules-engine', title: 'Edge Rules Engine', read: false, roleRight: 'edge-rules-engine', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/edge-locate', title: 'Edge Locate', read: false, roleRight: 'edge-locate', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/edge-locate-new', title: 'Edge Locate Visualization', read: false, roleRight: 'edge-locate-visualization', type: 'link', icon: 'la la-rocket',
    //       },

    //       {
    //         path: '/coverage-report', title: 'Coverage Report', read: false, roleRight: 'coverage-report', type: 'link', icon: 'la la-rocket',
    //       },
    //       {
    //         path: '/edge-geo-fencing-control', title: 'Edge Geo-Fencing Control', read: false, roleRight: 'edge-geo-fencing-control', type: 'link', icon: 'la la-rocket'
    //       },


    //     ]
    //   },
    //   // { headTitle: 'Intelligence' },
    //   {
    //     title: 'Intelligence', icon: 'fas fa-lightbulb', read: false, roleRight: 'networkModel', type: 'sub', active: false,
    //     children: [

    //       {
    //         path: '/edge-intelligence', title: 'Edge Intelligence', read: false, roleRight: 'edge-intelligence', type: 'link', icon: 'ti-pencil-alt',
    //       },
    //       {
    //         path: '/ml-models', title: 'ML Models ', read: false, roleRight: 'ml-models', type: 'link', icon: 'icon ion-ios-stats',
    //       },
    //       {
    //         path: '/model-training', title: 'Model Training', read: false, roleRight: 'model-training', type: 'link', icon: 'fe fe-airplay', 
    //       },
    //       {
    //         path: '/topology-manager', title: 'Topology Manager', read: false, roleRight: 'topology-manager', type: 'link', icon: 'fe fe-airplay',
    //       },
    //       {
    //         path: '/data-model', title: 'Data Model', read: false, roleRight: 'data-model', type: 'link', icon: 'fe fe-airplay',
    //       },
    //       {
    //         path: '/data-modeling', title: 'Data Modeling', read: false, roleRight: 'data-modeling', type: 'link', icon: 'fe fe-airplay',
    //       },
    //     ]
    //   },
    //   // { headTitle: 'Actionability' },
    //   {
    //     title: 'Actionability', icon: 'fas fa-bolt', type: 'sub', active: false,
    //     children: [
    //       {
    //         path: '/edge-command-control', title: 'Edge Command Control', read: false, roleRight: 'edge-command-control', type: 'link'
    //       },
    //       {
    //         path: '/edge-rules-engine', title: 'Edge Rule Engine', read: false, roleRight: 'edge-rules-engine', type: 'link'
    //       },
    //       {
    //         path: '/geo-fence', title: 'Geo-Fence', read: false, roleRight: 'geo-fence', type: 'link'
    //       },
    //       {
    //         path: '/live-walk-test', title: 'Active Test', read: false, roleRight: 'live-walk-test', type: 'link'
    //       },
    //       {
    //         path: '/video-stream', title: 'Video Stream', read: false, roleRight: 'video-stream', type: 'link'
    //       },
    //       {
    //         path: '/live-walk-test/walktest-scheduler', title: 'Test Scheduler', read: false, roleRight: 'walk-test-scheduler', type: 'link'
    //       },
    //       {
    //         path: '/live-walk-test/device-logs', title: 'QXDM Logs', read: false, roleRight: 'device-log-test', type: 'link'
    //       },
    //     ]
    //   },
    //   // { headTitle: 'Admin' },
    //   {
    //     title: 'Administration', icon: 'fas fa-user-cog', type: 'sub', active: false,
    //     children: [
    //       { path: '/help', title: 'Help', read: false, roleRight: 'help', icon: 'fe fe-airplay', type: 'link', },
    //       { path: '/api-gateway-control', title: 'API Gateway Control', read: false, roleRight: 'api-gateway-control', icon: 'fe fe-airplay', type: 'link', },
    //       { path: '/alarm-config', title: 'Alarm Configurations', read: false, roleRight: 'alarm-config', icon: 'fe fe-airplay', type: 'link', },
    //       {
    //         path: '/edge-management', icon: 'si si-layers', title: 'Edge Management', read: false, roleRight: 'edge-management', type: 'link',
    //       },
    //       {
    //         path: '/admin', icon: 'fe fe-alert-triangle', title: 'Admin', read: false, roleRight: 'admin', type: 'link',
    //       },
    //       {
    //         path: '/cloud-management', icon: 'fe fe-airplay', title: 'Cloud Management', read: false, roleRight: 'cloud-management', type: 'link',
    //       },
    //       {
    //         path: '/mno-mapping', icon: 'fe fe-airplay', title: 'MNO Mapping', read: false, roleRight: 'mno-mapping', type: 'link', 
    //       },
    //       {
    //         path: '/groups-manager', icon: 'fe fe-airplay', title: 'Groups Manager', read: false, roleRight: 'groups-manager', type: 'link', 
    //       },

    //       {
    //         path: '/floor-maps-manager', icon: 'fe fe-airplay', title: 'Floor Maps Manager', read: false, roleRight: 'floor-maps-manager', type: 'link', 
    //       },
    //       {
    //         path: '/devices-setup/setup', icon: 'fe fe-airplay', title: 'Device Locator', read: false, roleRight: 'device-locator', type: 'link', 
    //       },
    //       {
    //         path: '/device-upgrade-manager', icon: 'fe fe-airplay', title: 'Device Upgrade Manager', read: false, roleRight: 'device-upgrade-manager', type: 'link'
    //       },
    //       {
    //         path: '/diagnostic-tests', icon: 'fe fe-airplay', title: 'Diagnostics', read: false, roleRight: 'diagnostic-tests', type: 'link',
    //       },
    //       {
    //         path: '/users-manager', icon: 'fe fe-airplay', title: 'Users Manager', read: false, roleRight: 'users-manager', type: 'link'
    //       },
    //       {
    //         path: '/roles-manager', icon: 'fe fe-airplay', title: 'Roles Manager', read: false, roleRight: 'roles-manager', type: 'link'
    //       },
    //       {
    //         path: '/device-configuration', icon: 'fe fe-airplay', title: 'Device Configuration', read: false, roleRight: 'device-configuration', type: 'link'
    //       },
    //       { path: '/global-configuration', title: 'Global Configurations', read: true, roleRight: 'global-configuration', icon: 'fe fe-airplay', type: 'link' },
    //       { path: '/global-notifications', title: 'Global Notifications', read: true, roleRight: 'global-notifications', icon: 'fe fe-airplay', type: 'link' },
    //       { path: '/deviceInventory', title: 'Device Inventory', read: true, roleRight: 'device-inventory', icon: 'fe fe-airplay', type: 'link' },
         


    //     ]
    //   },
    //   // {
    //   //   path: '/info', title: 'Compliance Info', read: false, roleRight: 'compliance-info', type: 'link', icon: 'la la-info', active: true
    //   // }


    // ]

        this.menuItems = [
      {
        path: '/dashboard', title: 'Home', read: false, roleRight: 'home', type: 'link', icon: 'fas fa-home', active: true
      },
      // {
      //   path: '/topology', title: 'Topology', read: false, roleRight: 'topology', type: 'link', icon: 'la la-rocket',
      // },

      // { headTitle: 'Visibility' }, 
      {
        title: 'Visibility', icon: 'fas fa-globe-africa', read: false, roleRight: 'networkModel', type: 'sub', active: false,
        children: [
          { path: '/alaram-dashboard', title: 'Alarms', read: true, roleRight: 'alarms-manager', icon: 'fa-siren-on', type: 'link' },
          {
            path: '/assets', title: 'Assets', read: false, roleRight: 'assets', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/devices-view', title: 'Devices View', read: false, roleRight: 'devices-view', type: 'link', icon: 'fas fa-map-marked-alt',
          },
          {
            path: '/test-reports', title: 'Automation Test Reports', read: false, roleRight: 'automation_report', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/walktest-detailed-report', title: 'Detailed Report', read: false, roleRight: 'walk_test_detailed_report', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/walktest-report-table', title: 'Download CSV Data', read: false, roleRight: 'active_test_report', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/globalCompCharts', title: 'Global Comparison Charts', read: false, roleRight: 'global_comparison', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/telemetry', title: 'Telemetry', read: false, roleRight: 'telemetry', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/walktest-summary', title: 'Walk Test Summary', read: false, roleRight: 'walk_test_summary', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/walktest-report', title: 'Walk Test View', read: false, roleRight: 'walk_test_report', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/wifi-logs', title: 'WiFi Logs', read: false, roleRight: 'wifi-logs', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/urc-logs', title: 'URC Logs', read: false, roleRight: 'urc-logs', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/baseline-approval', title: 'Security Baseline Approval', read: false, roleRight: 'baseline-approval', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/transition-report', title: 'Security Transition Report', read: false, roleRight: 'transition-report', type: 'link', icon: 'la la-rocket',
          },
          {
            path: '/security-test-results', title: 'Security Test Results', read: false, roleRight: 'walk_test_report', type: 'link', icon: 'la la-rocket',
          },

          {
            path: '/cell-analysis', title: 'Physical Cell Analysis Report', read: false, roleRight: 'physcial_cell_analysis_report', type: 'link', icon: 'la la-rocket',
          },
          // {
          //   path: '/coverage-report', title: 'Coverage Report', read: false, roleRight: 'coverage-report', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/kpidashboard', title: 'Dashboard', read: false, roleRight: 'dashboard', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/devices', title: 'Devices', read: false, roleRight: 'devices', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/edge-geo-fencing-control', title: 'Edge Geo-Fencing Control', read: false, roleRight: 'edge-geo-fencing-control', type: 'link', icon: 'la la-rocket'
          // },
          // {
          //   path: '/edge-locate', title: 'Edge Locate', read: false, roleRight: 'edge-locate', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/edge-locate-new', title: 'Edge Locate Visualization', read: false, roleRight: 'edge-locate-visualization', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/edge-rules-engine', title: 'Edge Rules Engine', read: false, roleRight: 'edge-rules-engine', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/gps-report', title: 'GPS Report', read: false, roleRight: 'gps_report', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/sensors', title: 'Sensors', read: false, roleRight: 'sensors', type: 'link', icon: 'la la-rocket',
          // },
          // {
          //   path: '/signal-heatmap', title: 'Signal Heatmap', read: false, roleRight: 'signal_heat_map', type: 'link', icon: 'la la-rocket'
          // },
          // {
          //   path: '/statistics', title: 'Statistics', read: false, roleRight: 'statistics', type: 'link', icon: 'la la-rocket',
          // },
        ]
      },
      // { headTitle: 'Intelligence' },
      {
        title: 'Intelligence', icon: 'fas fa-lightbulb', read: false, roleRight: 'networkModel', type: 'sub', active: false,
        children: [
          {
            path: '/data-model', title: 'Data Model', read: false, roleRight: 'data-model', type: 'link', icon: 'fe fe-airplay',
          },
          {
            path: '/edge-intelligence', title: 'Edge Intelligence', read: false, roleRight: 'edge-intelligence', type: 'link', icon: 'ti-pencil-alt',
          },
          // {
          //   path: '/data-modeling', title: 'Data Modeling', read: false, roleRight: 'data-modeling', type: 'link', icon: 'fe fe-airplay',
          // },
          // {
          //   path: '/ml-models', title: 'ML Models ', read: false, roleRight: 'ml-models', type: 'link', icon: 'icon ion-ios-stats',
          // },
          // {
          //   path: '/model-training', title: 'Model Training', read: false, roleRight: 'model-training', type: 'link', icon: 'fe fe-airplay',
          // },
          // {
          //   path: '/topology-manager', title: 'Topology Manager', read: false, roleRight: 'topology-manager', type: 'link', icon: 'fe fe-airplay',
          // },
        ]
      },
      // { headTitle: 'Actionability' },
      {
        title: 'Actionability', icon: 'fas fa-bolt', type: 'sub', active: false,
        children: [
          {
            path: '/live-walk-test', title: 'Active Test', read: false, roleRight: 'live-walk-test', type: 'link'
          },
            {
            path: '/live-walk-test/walktest-scheduler', title: 'Test Scheduler', read: false, roleRight: 'walk-test-scheduler', type: 'link'
          },
          {
            path: '/security-live-test', title: 'Security Live Test', read: false, roleRight: 'security-test', type: 'link'
          },
           {
            path: '/security-test-scheduler', title: 'Security Test Scheduler', read: false, roleRight: 'walk-test-scheduler', type: 'link'
          },
          {
            path: '/live-walk-test/device-logs', title: 'QXDM Logs', read: false, roleRight: 'device-log-test', type: 'link'
          },
          // {
          //   path: '/security-live-test', title: 'Security Live Test', read: false, roleRight: 'security-live-test', type: 'link'
          // },
          // {
          //   path: '/edge-command-control', title: 'Edge Command Control', read: false, roleRight: 'edge-command-control', type: 'link'
          // },
          // {
          //   path: '/edge-rules-engine', title: 'Edge Rule Engine', read: false, roleRight: 'edge-rules-engine', type: 'link'
          // },
          // {
          //   path: '/geo-fence', title: 'Geo-Fence', read: false, roleRight: 'geo-fence', type: 'link'
          // },
          // {
          //   path: '/video-stream', title: 'Video Stream', read: false, roleRight: 'video-stream', type: 'link'
          // },
        ]
      },
      // { headTitle: 'Admin' },
      {
        title: 'Administration', icon: 'fas fa-user-cog', type: 'sub', active: false,
        children: [
          {
            path: '/admin', icon: 'fe fe-alert-triangle', title: 'Admin', read: false, roleRight: 'admin', type: 'link',
          },
          { path: '/alarm-config', title: 'Alarm Configurations', read: false, roleRight: 'alarm-config', icon: 'fe fe-airplay', type: 'link', },
          {
            path: '/device-configuration', icon: 'fe fe-airplay', title: 'Device Configuration', read: false, roleRight: 'device-configuration', type: 'link'
          },
          { path: '/deviceInventory', title: 'Device Inventory', read: true, roleRight: 'device-inventory', icon: 'fe fe-airplay', type: 'link' },
          {
            path: '/devices-setup/setup', icon: 'fe fe-airplay', title: 'Device Locator', read: false, roleRight: 'device-locator', type: 'link',
          },
          {
            path: '/device-upgrade-manager', icon: 'fe fe-airplay', title: 'Device Upgrade Manager', read: false, roleRight: 'device-upgrade-manager', type: 'link'
          },
          {
            path: '/diagnostic-tests', icon: 'fe fe-airplay', title: 'Diagnostics', read: false, roleRight: 'diagnostic-tests', type: 'link',
          },
          {
            path: '/floor-maps-manager', icon: 'fe fe-airplay', title: 'Floor Maps Manager', read: false, roleRight: 'floor-maps-manager', type: 'link',
          },
          { path: '/global-configuration', title: 'Global Configurations', read: true, roleRight: 'global-configuration', icon: 'fe fe-airplay', type: 'link' },
          { path: '/global-notifications', title: 'Global Notifications', read: true, roleRight: 'global-notifications', icon: 'fe fe-airplay', type: 'link' },
          {
            path: '/groups-manager', icon: 'fe fe-airplay', title: 'Groups Manager', read: false, roleRight: 'groups-manager', type: 'link',
          },
          { path: '/help', title: 'Help', read: false, roleRight: 'help', icon: 'fe fe-airplay', type: 'link', },
          {
            path: '/mno-mapping', icon: 'fe fe-airplay', title: 'MNO Mapping', read: false, roleRight: 'mno-mapping', type: 'link',
          },
          {
            path: '/roles-manager', icon: 'fe fe-airplay', title: 'Roles Manager', read: false, roleRight: 'roles-manager', type: 'link'
          },
          {
            path: '/users-manager', icon: 'fe fe-airplay', title: 'Users Manager', read: false, roleRight: 'users-manager', type: 'link'
          },
          // { path: '/api-gateway-control', title: 'API Gateway Control', read: false, roleRight: 'api-gateway-control', icon: 'fe fe-airplay', type: 'link', },
          // {
          //   path: '/cloud-management', icon: 'fe fe-airplay', title: 'Cloud Management', read: false, roleRight: 'cloud-management', type: 'link',
          // },
          
          // {
          //   path: '/edge-management', icon: 'si si-layers', title: 'Edge Management', read: false, roleRight: 'edge-management', type: 'link',
          // },
        ]
      },
      // {
      //   path: '/info', title: 'Compliance Info', read: false, roleRight: 'compliance-info', type: 'link', icon: 'la la-info', active: true
      // }


    ]
    
    this.menuItems.map(item => {
      item?.children && item.children.map(res=>{
        res.read = this.roleRightCheck(item.title, res.roleRight);
      })
    })
    // //console.log(this.menuItems);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.menuItems.filter(items => {
          if (items.path === event.url) {
            this.setNavActive(items);
          }
          if (!items.children) { return false; }
          items.children.filter(subItems => {
            if (subItems.path === event.url) {
              this.setNavActive(subItems);
            }
            if (!subItems.children) { return false; }
            subItems.children.filter(subSubItems => {
              if (subSubItems.path === event.url) {
                this.setNavActive(subSubItems);
              }
            });
          });
        });
      }
    });

    //   this.menuItems = menuItems;
    //   this.router.events.subscribe((event) => {
    //     if (event instanceof NavigationEnd) {
    //       menuItems.filter(items => {
    //         if (items.path === event.url) {         
    //           this.setNavActive(items);
    //         }
    //         if (!items.children) { return false; }
    //         items.children.filter(subItems => {
    //           if (subItems.path === event.url) {
    //             this.setNavActive(subItems);
    //           }
    //           if (!subItems.children) { return false; }
    //           subItems.children.filter(subSubItems => {
    //             if (subSubItems.path === event.url) {
    //               this.setNavActive(subSubItems);
    //             }
    //           });
    //         });
    //       });
    //     }
    //   });
    // });
  }
  ngOnDestroy(): void {
    this.fetchDeploymentName.unsubscribe();
  }
  roleRightCheck(menu, submenu){
    // //console.log(menu, submenu)
    // //console.log(this.roleRightObj?.[menu]?.[submenu])
    return this.roleRightObj?.[menu]?.[submenu];
  }
  // Active NavBar State
  setNavActive(item) {
    this.authService.getPageNameData(item.title);
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
        document.querySelector('.main-body').classList.remove('sidenav-toggled');
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }
  openNewWindow(menuItem) {
    var popup = window.open(menuItem.url, '');
    const data = {
      "token": window.localStorage.getItem('token'),
      "message": window.localStorage.getItem('token')
    }
    let clearInt = setInterval(() => {
      popup.postMessage(data, '*')
    }, 1000)
    setTimeout(() => {
      clearInterval(clearInt);
    }, 3000);
  }
  // Click Toggle menu
  // toggleNavActive(item, type) {  //old 
  //   if (type != 2 && item != 'Live Walk Test') {
  //     this.authService.getPageNameData(item.title);
  //   }
  //   this.navServices.toggleSidebarVisibility(false);
  //   if (!item.active) {
  //     this.menuItems.forEach(a => {
  //       if (this.menuItems.includes(item)) {
  //         a.active = false;
  //       }
  //       if (!a.children) { return false; }
  //       a.children.forEach(b => {
  //         if (type != 2 && item != 'Live Walk Test') {
  //           this.authService.getPageNameData(item.title);
  //         }
  //         if (a.children.includes(item)) {
  //           b.active = false;
  //         }
  //       });
  //     });
  //   }
  //   item.active = !item.active;  
  // }
  toggleNavActive(item) {
    console.log(item)
    if (item.type != null && item.type != 'sub') {
      this.router.navigateByUrl(item.path)
      this.authService.getPageNameData(item.title);
    }

    this.navServices.toggleSidebarVisibility(false);

    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          // if (type != 2 &&  item !='Live Walk Test') {
          //   this.authService.getPageNameData(item.title);
          // }
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;

    if (item.type === 'sub') {
      const sidebarEl = this.elRef.nativeElement.querySelector('.app-sidebar');
      if (sidebarEl) {
        sidebarEl.scrollTop = 0;
      }
    }
  }
  ngOnInit(): void {
    this.versionNo = this.version;
    let data = !(localStorage.getItem('sideMenuList') == 'undefined' || localStorage.getItem('sideMenuList') == undefined) ? JSON.parse(localStorage.getItem('sideMenuList')) : {};
    
    this.menujsonlist = data ? data : {};

    if (Object.keys(this.menujsonlist).length === 0) {
      this.isEmptyObj = true;
    } else {
      this.isEmptyObj = false;
    }
    // console.log(JSON.stringify(data), this.isEmptyObj);
    this.navServices.sidebarVisibilityChange.subscribe(value => {
      this.activateSideNav = value ? value : false;
    });

    this.fetchDeploymentName = this.authService.fetchDeploymentName.subscribe(res=>{
      //console.log("fffffffffffffffff");
      this.getDeploymentName();
    })

  }

  handleCollapse(toggle:boolean){
    // //console.log(toggle);
if(!toggle){
  this.navServices.isActiveMenu = false;
  if ((this.navServices.collapseSidebar = true)) {
    this.navServices.toggleSidebarVisibility(true)
    document.querySelector('.main-body').classList.add('sidenav-toggled');
}
}else{
  this.navServices.isActiveMenu = true;
  // this.navServices.activateSideNav=false;
  this.navServices.toggleSidebarVisibility(false)
  if ((this.navServices.collapseSidebar = true)) {
    document.querySelector('.main-body').classList.remove('sidenav-toggled');
  }
 
}
this.sidebarCollapsed = !toggle;
  }
  hoverEffect($event, type) {
    this.sendMouseEvent.emit($event.type == 'mouseover' ? 'sidenav-toggled-open' : '');
    // this.mainSidebarOpen = $event.type == 'mouseover' ? 'sidenav-toggled-open' : '';
  }


  getDeploymentName(){
    this.authService.getDeploymentName().subscribe((res:any)=>{
      //console.log(res);
      this.deploymentName = res?.result?.hits?.[0]?._source?.name;
    })
  }
}
